import React, { useState, useEffect } from 'react';
import Header from 'src/components/App/Header';
import Sidebar from 'src/components/App/Sidebar';
import { Box, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useLocation, useNavigate } from 'react-router-dom';

function AppLayout({ children }) {
  const theme = useTheme();
  const location = useLocation();
  const navigate = useNavigate();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [mobileDrawerOpen, setMobileDrawerOpen] = useState(false);

  const staffEmail = (localStorage.getItem('staffEmail') || localStorage.getItem('STAFFEMAIL') || '').toLowerCase();
  const isSanginiOnly = staffEmail.includes('sangini') || staffEmail === 'tapan@sanginihospital.com';

  useEffect(() => {
    if (isSanginiOnly && location.pathname !== '/appointments' && !location.pathname.startsWith('/auth')) {
      navigate('/appointments', { replace: true });
    }
  }, [isSanginiOnly, location.pathname, navigate]);

  const handleDrawerToggle = () => {
    setMobileDrawerOpen((prev) => !prev);
  };

  return (
    <Box
      sx={{
        display: 'flex',
        minHeight: '100vh',
        bgcolor: theme.palette.background.default,
        transition: 'background-color 0.2s ease',
      }}
    >
      {/* Desktop & Mobile Sidebar Navigation */}
      <Sidebar
        open={mobileDrawerOpen}
        onClose={() => setMobileDrawerOpen(false)}
        isMobile={isMobile}
      />

      {/* Main Content Area */}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          minWidth: 0,
          display: 'flex',
          flexDirection: 'column',
          minHeight: '100vh',
          bgcolor: theme.palette.background.default,
          transition: 'background-color 0.2s ease',
        }}
      >
        <Header onDrawerToggle={handleDrawerToggle} />

        <Box
          sx={{
            flex: 1,
            p: { xs: 2, sm: 3, md: 4 },
            maxWidth: '1600px',
            width: '100%',
            mx: 'auto',
          }}
        >
          {children}
        </Box>
      </Box>
    </Box>
  );
}

export default AppLayout;
